// Frozen so the shared palette can never be mutated by any consumer (`returnColormap` hands out this
// exact reference). `as const` blocks mutation at compile time, Object.freeze at runtime.
const colormap = Object.freeze([
  "#0077ff",
  "#f39900",
  "#66ff33",
  "#ff3344",
  "#fed700",
  "#cc33ff",
  "#00ffc7",
  "#6734ff",
  "#fc5300",
] as const);

export const returnColormap = (): readonly string[] => colormap;

/** Reserved palette color for the primary selected run. */
export const primaryRunColor = colormap[0];

/** Reserved palette color for the secondary selected run. */
export const secondaryRunColor = colormap[1];

/** Palette for all other (non primary/secondary) runs — the colormap without the two reserved colors. */
export const returnRunColormap = () => colormap.slice(2);
